import { Alert, Button } from '@mui/material';

export default function LoadError({ children, onRetry }) {
  return <Alert severity="error" sx={{ mb: 1 }} action={onRetry
    ? <Button color="inherit" size="small" onClick={onRetry}>Erneut versuchen</Button> : undefined}>
    {children}
  </Alert>;
}
